import { makeStyles } from '@freighthub/silhouette-core'
import { FC, useContext } from 'react'
import { useI18n } from 'utils/localisation'

import { ITimestampJSON } from '../domain/TransportPlanTimestamp'
import { formatTimestampToString, formatTpTimestampToString } from '../service/format'
import { TpTimestampRangeCtx, TTpTimestampRangeCtx } from '../service/TpTimestampRangeContext'
import { useDelayViewData } from './TpDelay'
import { DelayString } from './TpDelayString'

const useStyles = makeStyles({
  nowrap: {
    whiteSpace: 'nowrap',
  },
})
interface TTpTimestampCtx {
  showReason: boolean
  showTooltip: boolean
  showDelay: boolean
  useShortDate: boolean
  useIntervalDescription: boolean
}

interface TTpTimestampProps {
  aggregatedTimestamp: ITimestampJSON
  revisedTimestamp: ITimestampJSON
}

export interface LeanTpTimestampSingleProps extends TTpTimestampProps, Partial<TTpTimestampCtx> {}

export const LeanTpTimestampSingle: FC<LeanTpTimestampSingleProps> = ({
  aggregatedTimestamp,
  revisedTimestamp,
  showTooltip = false,
  showReason = false,
  showDelay = true,
  useShortDate = false,
  useIntervalDescription = false,
}) => {
  const { translateIfExists, translate } = useI18n()
  const classes = useStyles()
  // @ts-expect-error TS(2345) FIXME: Argument of type 'number | undefined' is not assig... Remove this comment to see the full error message
  const { delayString, colorClass, isZero } = useDelayViewData(aggregatedTimestamp.delay)

  const initialDate = showTooltip && revisedTimestamp.date ? revisedTimestamp.date : undefined
  const isCascaded = !!aggregatedTimestamp.causedBy

  return (
    <span>
      <span className={classes.nowrap}>
        {useIntervalDescription
          ? formatTpTimestampToString(translate, aggregatedTimestamp, useShortDate)
          : formatTimestampToString(aggregatedTimestamp, useShortDate)}
      </span>
      {!isZero && showDelay && (
        // @ts-expect-error TS(2322) FIXME: Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
        <DelayString colorClass={colorClass} delayString={delayString} initialDate={initialDate} />
      )}
      {!isZero && showReason && !isCascaded && (
        <span className={colorClass} style={{ display: 'block', whiteSpace: 'normal' }}>
          {translateIfExists(aggregatedTimestamp.reason)}
        </span>
      )}
    </span>
  )
}

export const TPTimestampSingle: FC<TTpTimestampProps> = (props) => {
  const { showReason, showDelay, showTooltip, useShortDate, useIntervalDescription }: TTpTimestampRangeCtx =
    useContext(TpTimestampRangeCtx)
  return (
    <LeanTpTimestampSingle
      showReason={showReason}
      showDelay={showDelay}
      showTooltip={showTooltip}
      useShortDate={useShortDate}
      useIntervalDescription={useIntervalDescription}
      {...props}
    />
  )
}
